import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import AnimeGrid from './components/AnimeGrid';
import Footer from './components/Footer';
import CategoryPage from './components/CategoryPage';
import MovieDetail from './components/MovieDetail';
import Watch from './pages/Watch';
import Profile from './pages/Profile';
import NativeBanner1 from './components/NativeBanner1';
import AdBanner from './components/AdBanner';

// Admin Components
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminMovies from './pages/AdminMovies';
import AdminEpisodes from './pages/AdminEpisodes';
import AdminMembers from './pages/AdminMembers';
import AdminNotifications from './pages/AdminNotifications';
import AdminSettings from './pages/AdminSettings';
import AdminServers from './pages/AdminServers';
import AdminCategories from './pages/AdminCategories';
import AdminStatus from './pages/AdminStatus';
import AdminGroups from './pages/AdminGroups';
import AdminCovers from './pages/AdminCovers';
import AdminMovieSettings from './pages/AdminMovieSettings';
import AdminReports from './pages/AdminReports';
import AdminLeech from './pages/AdminLeech';
import AdminUpload from './pages/AdminUpload';

import './styles/App.css';
import './styles/Header.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <div className="app">
              <Header />
              <NativeBanner1 />
              <main className="main-content">
                <AnimeGrid />
              </main>
              <Footer />
              <AdBanner />
            </div>
          } />
          <Route path="/category/:slug" element={
            <div className="app">
              <Header />
              <NativeBanner1 />
              <main className="main-content">
                <CategoryPage />
              </main>
              <Footer />
              <AdBanner />
            </div>
          } />
          <Route path="/movie/:slug" element={
            <div className="app">
              <Header />
              <NativeBanner1 />
              <main className="main-content">
                <MovieDetail />
              </main>
              <Footer />
              <AdBanner />
            </div>
          } />
          <Route path="/watch/:url" element={
            <div className="app">
              <Header />
              <NativeBanner1 />
              <main className="main-content">
                <Watch />
              </main>
              <Footer />
              <AdBanner />
            </div>
          } />
          <Route path="/profile" element={
            <div className="app">
              <Header />
              <main className="main-content">
                <Profile />
              </main>
              <Footer />
            </div>
          } />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="movies" element={<AdminMovies />} />
            <Route path="movies/:slug/episodes" element={<AdminEpisodes />} />
            <Route path="movie-settings" element={<AdminMovieSettings />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="status" element={<AdminStatus />} />
            <Route path="groups" element={<AdminGroups />} />
            <Route path="covers" element={<AdminCovers />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="leech" element={<AdminLeech />} />
            <Route path="upload" element={<AdminUpload />} />
            <Route path="servers" element={<AdminServers />} />
            <Route path="members" element={<AdminMembers />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
